import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageComponent } from './page/page.component';
import { AuthGuard } from '@core/guards/auth.guard';

import { AnalyticsGuard } from '@core/guards/analytics.guard';

import { EntityCodes } from '@core/models/global-entities/global-enums';
import { LicenceGuard } from '@core/guards/licence.guard';
import { AnalyticsComponent } from '@features/common/components/analytics/analytics.component';
import { ComplainAttachmentStreamComponent } from '@features/common/components/complain-attachment-stream/complain-attachment-stream.component';
import {
  AuthActionCodes,
  PageRights,
} from '@core/models/global-entities/global-enums';
// import { AuthGuard } from '@core/guards/auth.guard';
// import { UnauthGuard } from '@core/guards/unauth.guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'app',
  },
  // {
  //    path: 'account',
  //    // canActivate: [UnauthGuard],
  //    // canActivateChild: [UnauthGuard],
  //    // canLoad: [UnauthGuard],
  //    loadChildren: './modules/account/account.module#AccountModule'
  // },
  {
    path: 'app',
    // canActivate: [AuthGuard],
    // canActivateChild: [AuthGuard],
    // canLoad: [AuthGuard],
    component: PageComponent,
    canActivateChild: [LicenceGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'workorder/console',
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./modules/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
          ),
        data: {
          ActiveParentRoute: 'Dashboard',
        },
      },
      {
        path: 'pm',
        loadChildren: () =>
          import('./modules/pm/pm.module').then((m) => m.PmModule),
        data: { ActiveParentRoute: 'PM', EntityCode: EntityCodes.PM },
        canLoad: [AuthGuard],
      },
      {
        path: 'workorder',
        loadChildren: () =>
          import('./modules/workorder/workorder.module').then(
            (m) => m.WorkorderModule
          ),
        data: {
          ActiveParentRoute: 'Workorder',
          EntityCode: EntityCodes.WorkOrder,
        },
      },
      {
        path: 'asset',
        loadChildren: () =>
          import('./modules/assets/assets.module').then((m) => m.AssetsModule),
        data: { ActiveParentRoute: 'Asset', EntityCode: EntityCodes.Asset },
        canLoad: [AuthGuard],
      },
      {
        path: 'checklist',
        loadChildren: () =>
          import('./modules/checklist/checklist.module').then(
            (m) => m.ChecklistModule
          ),
        data: {
          ActiveParentRoute: 'Checklist',
          EntityCode: EntityCodes.CheckList,
        },
        canLoad: [AuthGuard],
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./modules/settings/settings.module').then(
            (m) => m.SettingsModule
          ),
        data: { ActiveParentRoute: 'Settings' },
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./modules/reports/reports.module').then(
            (m) => m.ReportsModule
          ),
        data: {
          ActiveParentRoute: 'Reports',
          EntityCode: EntityCodes.StdReport,
        },
        // canLoad: [AuthGuard],
      },

      {
        path: 'analytics',
        component: AnalyticsComponent,
        data: {
          ActiveParentRoute: 'Analytics',
          EntityCode: EntityCodes.StdReport,
          ActionCode: AuthActionCodes.Report_Run,
        },
        canLoad: [AnalyticsGuard],
        canActivate: [AnalyticsGuard],
      },
    ],
  },
  // {
  //   path: 'Pages/ComplaintPrint',
  //   component: ComplaintPrintComponent,
  // },
  // {
  //   path: 'Pages/Complain_GetAttachmentStream',
  //   component: ComplainAttachmentStreamComponent,
  // },

  //
];
// canActivate: [AuthGuard],
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: true,
      relativeLinkResolution: 'legacy',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
